(() => {
  const hideInboxSignIn = (root) => {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('button.sign-in-button').forEach((button) => {
      button.setAttribute('hidden', '');
      button.setAttribute('aria-hidden', 'true');
    });

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) hideInboxSignIn(element.shadowRoot);
    });
  };

  hideInboxSignIn(document);

  const hideTimer = window.setInterval(() => hideInboxSignIn(document), 250);
  window.setTimeout(() => window.clearInterval(hideTimer), 30000);
})();
